module.exports = __webpack_public_path__ + "img/text_feminista_en.a869fb75.png";